import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.unittitle.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_UNIT_TITLE_ASYNC: `${uid}.saveUnitTitleAsync`,
    SAVE_UNIT_TITLE_SUCCESS: `${uid}.saveUnitTitleSuccess`,
    SAVE_UNIT_TITLE_FAILURE: `${uid}.saveUnitTitleFailure`,
    CREATE_UNIT_TITLE: `${uid}.createUnitTitle`
};

export { ActionTypes };
